// import React from "react";
// import { BrowserRouter } from "react-router-dom";
// import ReactDOM from "react-dom";

// import { Provider } from "react-redux";

// import { Footer, Header } from "../components";

import "../styles/base/_typography.scss";
import "../styles/base/_layout.scss";
import "../styles/components/_spinners.scss";

// const renderHeader = (store, element) => {
//   const target = typeof element === 'object' ? element : document.getElementById(element);

//   if (target) {
//     ReactDOM.render(
//       <Provider store={store}>
//         <BrowserRouter>
//           <Header navlinks />
//         </BrowserRouter>
//       </Provider>,
//       target,
//     );
//   }
// };

// const renderFooter = (store, element) => {
//   const target = typeof element === 'object' ? element : document.getElementById(element);

//   if (target) {
//     ReactDOM.render(
//       <Provider store={store}>
//         <BrowserRouter>
//           <Footer />
//         </BrowserRouter>
//       </Provider>,
//       target,
//     );
//   }
// };

const configureRenders = (store) => {
  // (Site.renderHeader = (element) => renderHeader(store, element)), (Site.renderFooter = (element) => renderFooter(store, element));

  if (document) {
    const dispatchRenderReady = () => {
      const reactRenderReady = new Event("reactRenderReady");

      document.dispatchEvent(reactRenderReady);
    };

    if (/complete|interactive|loaded/.test(document.readyState)) {
      dispatchRenderReady();
    } else {
      document.addEventListener("DOMContentLoaded", dispatchRenderReady, false);
    }
  }
};

export default configureRenders;
